// extracted by mini-css-extract-plugin
export default {"_":"ContactCard____Bgt4S","contactLine":"ContactCard_contactLine__dzZma"};